import request from "@/utils/request";

export function getDictList(){
  return request({
    url: 'api/system/dict/type/listAll',
    method: 'get'
  })
}
